<app-edit-competition-import-row
  [dialogRef]="dialogRef"
>
</app-edit-competition-import-row>
